import { render, staticRenderFns } from "./risk-profile.vue?vue&type=template&id=7e91c9ad"
import script from "./risk-profile.vue?vue&type=script&lang=js"
export * from "./risk-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports